import React from 'react';
import { WidgetProps } from '@/lib/widgets/types';
import { StatsWidget } from './StatsWidget';
import { useFleetDashboardStats } from '@/hooks/use-fleet-dashboard-stats';

export function FleetDriversWidget(props: WidgetProps) {
  const { data: stats, isLoading } = useFleetDashboardStats();
  
  return (
    <StatsWidget
      {...props}
      title="Motoristas"
      value={isLoading ? "..." : stats?.totalDrivers?.toString() || "0"}
      description="Ativos na frota"
      icon="User"
      colorScheme="drivers"
      isLoading={isLoading}
    />
  );
}

export function FleetTripsWidget(props: WidgetProps) {
  const { data: stats, isLoading } = useFleetDashboardStats();
  
  return (
    <StatsWidget
      {...props}
      title="Viagens"
      value={isLoading ? "..." : stats?.totalTrips?.toString() || "0"}
      description="Este mês"
      icon="Route"
      colorScheme="trips"
      isLoading={isLoading}
    />
  );
}